import api from './api';
import logger from '../utils/logger';

export const authService = {
  async login(email, password) {
    const response = await api.post('/auth/login', { email, password });
    const { token, user } = response.data;
    
    localStorage.setItem('access_token', token);
    localStorage.setItem('user', JSON.stringify(user));
    
    return { access_token: token, user };
  },

  async register(name, email, password) {
    const response = await api.post('/auth/register', { name, email, password });
    return response.data;
  },

  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      logger.error('Logout error:', error);
    } finally {
      localStorage.removeItem('access_token');
      localStorage.removeItem('user');
    }
  },

  async getCurrentUser() {
    const response = await api.get('/auth/me');
    const user = response.data.user || response.data;
    localStorage.setItem('user', JSON.stringify(user));
    return user;
  },

  isAuthenticated() {
    return !!localStorage.getItem('access_token');
  },

  getUser() {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAdmin() {
    const user = this.getUser();
    return user?.admin === true;
  },

  async refreshToken() {
    try {
      const currentToken = localStorage.getItem('access_token');
      if (!currentToken) {
        throw new Error('No token available to refresh');
      }

      const response = await api.post('/auth/refresh');
      const { token } = response.data;

      if (token) {
        localStorage.setItem('access_token', token);
        return { access_token: token };
      } else {
        throw new Error('No token received from refresh');
      }
    } catch (error) {
      logger.error('Manual token refresh failed:', error);
      // Only clear auth data on authentication errors (401/403).
      // Network errors or server errors (5xx) should not invalidate the stored session.
      const status = error.response?.status;
      if (status === 401 || status === 403) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('user');
      }
      throw error;
    }
  }
};